module.exports = __webpack_public_path__ + "static/img/transaction.d778634f.svg";